import { z } from 'zod';

export const OnboardingCompBenefitsFormSchema = z.object({
  displayTimeUnit: z.enum(['Hourly', 'Daily']).nullable(),
});

export type OnboardingCompBenefits = z.infer<
  typeof OnboardingCompBenefitsFormSchema
>;
